import APIService from '../api';

export default class SearchService extends APIService {
  search(searchText: string, skip?: number) {
    return this.get(
      `/dashboard?search=${searchText || ''}&limit=3&skip=${skip || 0}`
    );
  }
}
